<template>
  <div class="flex">
    <div>
      <p>Поставить заявку в <strong>резерв</strong></p>
      <div class="input-group">
        <select v-model="hours" class="form-control">
          <option v-for="h in reserveHours" :value="h.hours">{{ h.title }}</option>
        </select>
        <div class="input-group-append">
          <LoadingButton
            :title="saveAfterOrderUpdate ? 'Будет установлена после сохранения заявки' : 'Установить'"
            :className="!saveAfterOrderUpdate ? 'btn btn-outline-info' : 'btn btn-info'"
            :loading="loading"
            :color="$constants.LOADING_COLOR"
            :onClick="() => saveReserve()"
          />
        </div>
      </div>
    </div>
    <div v-if="$editNewOrder.is_reserved" class="align-self-center m-0 ml-2 alert alert-info">
      <p>Заявка в резерве</p>
      <p>до <strong>{{ printDate($editNewOrder.reserved_till) }}</strong> ({{ printRemain() }})</p>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import moment from 'moment';

export default {
  components: {
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      saveAfterOrderUpdate: false,
      hours: 3,
      reserveHours: [
        {hours: 3, title: 'Резерв на 3 часа'},
        {hours: 6, title: 'Резерв на 6 часов'},
        {hours: 12, title: 'Резерв на 12 часов'},
        {hours: 24, title: 'Резерв на 24 часа'},
      ]
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters["orders/editNewOrder"];
    },
  },
  methods: {
    printRemain() {
      const reserved = moment(this.$editNewOrder.reserved_till);
      const hours = reserved.diff(moment(), 'hours');
      const minutes = hours * 60
      return hours + 'ч. ' + (reserved.diff(moment(), 'minutes') - minutes) + 'м.';
    },
    async saveReserve() {
      if (!this.$editNewOrder.id) {
        this.saveAfterOrderUpdate = !this.saveAfterOrderUpdate;
        return;
      }
      this.loading = true;
      const {data} = await api.post('/new/orders/updateByAction', {
        action: 'setToReservation',
        order_id: this.$editNewOrder.id,
        hours: this.hours
      })
      if (data.success) {
        this.$editNewOrder.is_reserved = true;
        this.$editNewOrder.reserved_till = data.orderData.reserved_till;
        if (!this.saveAfterOrderUpdate) toastr['success']('Сохранено');
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения резерва');
      }
      this.loading = false;
    }
  }
}

</script>
